import { StockChangeReason } from '../models/StockLine';

export default function getReasonOptions(intl, withDefault = true) {
  return [
    ...(withDefault
      ? [{ value: '-', label: intl.formatMessage({ id: 'stock.all' }) }]
      : []),
    {
      value: StockChangeReason.NONE,
      label: intl.formatMessage({ id: 'stock.reasonNone' }),
    },
    {
      value: StockChangeReason.INVENTORY,
      label: intl.formatMessage({ id: 'stock.reasonInventory' }),
    },
    {
      value: StockChangeReason.PRODUCT_ENTRY,
      label: intl.formatMessage({ id: 'stock.reasonProductEntry' }),
    },
    {
      value: StockChangeReason.MISMATCH,
      label: intl.formatMessage({ id: 'stock.reasonMismatch' }),
    },
    {
      value: StockChangeReason.BROKEN_POOR_CONDITION_EXPIRED,
      label: intl.formatMessage({
        id: 'stock.reasonBrokenPoorConditionExpired',
      }),
    },
    {
      value: StockChangeReason.SAMPLES,
      label: intl.formatMessage({ id: 'stock.reasonSamples' }),
    },
  ];
}
